import { apiGet } from '../client';
import type { Environment } from '../../constants';
import type {
  IAuditEntry,
  ISubscription,
  ITenantExtension,
  ITenantSummary,
  ITenantUser,
} from '../../types';

export const getTenant = (
  environment: Environment,
  name: string,
): Promise<{ data: ITenantSummary }> => apiGet(environment, `/tenants/${encodeURIComponent(name)}`);

export const getTenantUsers = (
  environment: Environment,
  name: string,
): Promise<{ data: { organisation_id: string | null; users: ITenantUser[] } }> =>
  apiGet(environment, `/tenants/${encodeURIComponent(name)}/users`);

export const getTenantExtensions = (
  environment: Environment,
  name: string,
): Promise<{ data: ITenantExtension[] }> =>
  apiGet(environment, `/tenants/${encodeURIComponent(name)}/extensions`);

export const getTenantSubscriptions = (
  environment: Environment,
  name: string,
): Promise<{ data: ISubscription[] }> =>
  apiGet(environment, `/tenants/${encodeURIComponent(name)}/subscriptions`);

export const getTenantAudit = (
  environment: Environment,
  name: string,
): Promise<{ data: IAuditEntry[] }> =>
  apiGet(environment, `/audit?tenant=${encodeURIComponent(name)}&limit=100`);
